import { TreeCardObject } from '../tree-card/tree-card-object.model';
import { OrderStatusObject } from '../order-status-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderTypeObject } from '../order-type-object.model';

export class CrmOrderObject extends TreeCardObject {

  private cont = 0;

  constructor(name: string, status: string, orderId: string, crmId: string) {
    super(name, 'ORDEN CRM', null, null, crmId, null,
      OrderStatusObject.createWithStatus(status), false, 1, orderId, OrderTypeObject.CRM);
  }

  static create(): CrmOrderObject {
    return new CrmOrderObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
  }

  public getRecursivityTreeCardList(): Array<TreeCardObject> {
    const level = 1;
    const list = new Array<TreeCardObject>();
    this.pushChildren(this, list, level);
    return list;
  }

  public pushChildren(treeCard: TreeCardObject, treeCardList: Array<TreeCardObject>, level: number): void {
    this.cont++;
    treeCard.setLevel(level);
    treeCard.setIndex(this.cont);
    treeCardList.push(treeCard);
    if (!treeCard.hasChildren()) {
      return;
    } else {
      level++;
      treeCard.getChildren().forEach((child) => {
        this.pushChildren(child, treeCardList, level);
      });
    }
    return;
  }

  public getCont() {
    return this.cont;
  }
}
